// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__12tXa","head":"ProcedureTableInfo_head__l1O1V"};